import { create } from 'zustand';

const useChatClient= create((set) => ({
  client: null,
  setClient: (newClient) => set({ client: newClient }),
}));

export default useChatClient;

